module.exports = __webpack_public_path__ + "media/images/emblems/Oberkirch_LU-28a25184b4d00b91a9f368d9cf4187b1.png";